import React from "react";
import Testimonials from "../Testimonials";
import Group256 from "../Group256";
import Group258 from "../Group258";
import "./Property1Frame18.css";

function Property1Frame18(props) {
  const { ellipse6, vatsalaWilson, loremIpsumDolorSi } = props;

  return (
    <div className="testimonials-2">
      <div className="group-257">
        <div className="testimonials-3">
          <div className="group-33-1">
            <img className="ellipse-6" src={ellipse6} />
          </div>
          <div className="flex-col-3">
            <div className="vatsala-wilson poppins-medium-tundora-17px">{vatsalaWilson}</div>
            <p className="lorem-ipsum-dolor-si montserrat-normal-tundora-14px">{loremIpsumDolorSi}</p>
          </div>
        </div>
        <div className="group-container">
          <div className="group-255"></div>
          <div className="group-256">
            <div className="ellipse-26"></div>
            <div className="ellipse-27"></div>
          </div>
        </div>
      </div>
      <div className="group-259">
        <Testimonials />
        <Group256 />
      </div>
      <div className="group-260">
        <Testimonials />
        <Group258 />
      </div>
    </div>
  );
}

export default Property1Frame18;
